import { validatePresence } from 'ember-changeset-validations/validators';
import { customMessageValidator } from 'uplisting-frontend/validators/custom-message';

export const PropertyMessageTagValidation = {
  hostFirstName: [
    customMessageValidator(
      'property_message_tag_first_name',
      validatePresence({ presence: true }),
    ),
  ],

  hostSurname: [
    customMessageValidator(
      'property_message_tag_surname',
      validatePresence({ presence: true }),
    ),
  ],
};
